import { useEffect, useRef } from "react";

export function useAutoSelectAiPrompt() {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.select();
    }
  }, []);

  return inputRef;
}
